// navigation-utils.js

export function cloneNavTreeWithDepthLimit(nodes, maxDepth, depth = 1) {
  if (!Array.isArray(nodes)) return [];

  return nodes.map(node => {
    const copy = { ...node };

    if (depth >= maxDepth) {
      copy.children = [];
    } else {
      copy.children = cloneNavTreeWithDepthLimit(node.children, maxDepth, depth + 1);
    }

    return copy;
  });
}

export function normaliseNavUrl(url) {
  return String(url || "").trim();
}

export function isExternalUrl(url) {
  const href = normaliseNavUrl(url);

  if (!href) return false;

  if (
    href.startsWith("#") ||
    href.startsWith("?") ||
    href.startsWith("mailto:") ||
    href.startsWith("tel:")
  ) {
    return false;
  }

  try {
    const target = new URL(href, window.location.origin);

    if (target.protocol !== "http:" && target.protocol !== "https:") {
      return false;
    }

    return target.origin !== window.location.origin;
  } catch (error) {
    return false;
  }
}

export function decorateExternalLink(link, url) {
  if (!link) return link;

  const href = url || link.getAttribute("href");

  if (!isExternalUrl(href)) return link;

  if (
    link.classList.contains("is-external") ||
    link.querySelector(".sz-link-external-icon")
  ) {
    return link;
  }

  link.classList.add("is-external");

  const icon = document.createElement("span");
  icon.className = "sz-link-external-icon";
  icon.setAttribute("aria-hidden", "true");
  icon.innerHTML = `<i class="bi bi-box-arrow-up-right"></i>`;

  const srText = document.createElement("span");
  srText.className = "visually-hidden";
  srText.textContent = " external link";

  link.appendChild(icon);
  link.appendChild(srText);

  return link;
}

export function createNavLink({
  url,
  label,
  className = "",
  isActive = false,
  current = false,
}) {
  const link = document.createElement("a");

  const href = normaliseNavUrl(url);

  link.href = href;
  link.textContent = label || "";

  if (className) link.className = className;
  if (isActive) link.classList.add("is-active");
  if (current) link.setAttribute("aria-current", "page");

  decorateExternalLink(link, href);

  return link;
}